// import React, { useRef } from 'react';
// import { InlineWidget } from 'react-calendly';
// import { Loader } from 'components';
//
// export const MyCalendlyComponent = () => {
//     const formContainerRef = useRef(null);
//
//
//     return (
//         <div className='calendly-wrapper'>
//             <div id="hubspot-form-container" ref={formContainerRef}></div>
//             <InlineWidget
//                 url="https://calendly.com/therapylake"
//                 styles={{
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     alignContent: 'center',
//                     height: '700px',
//                     width: '100%',
//                     position: 'relative',
//                 }}
//                 LoadingSpinner={() => <div style={{
//                     position: 'absolute',
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     alignContent: 'center',
//                     width: '100%',
//                     height: '100%',
//                 }}><Loader styles={{width: 150, height: 150, color: '#347AF0', margin: 'auto'}}/></div>}
//                 pageSettings={{
//                     backgroundColor: '#F8F8F8',
//                     hideEventTypeDetails: true,
//                     hideProfilePageViewed: true,
//                     hideGdprBanner: true,
//                     primaryColor: '#347AF0',
//                     textColor: '#2A2F35'
//                 }}
//             />
//         </div>
//     );
// };

import React, { memo, useMemo } from 'react';
import { InlineWidget } from 'react-calendly';
import { getCalendlyUtmParams, CALENDLY_URL } from 'utils';

export const MyCalendlyComponent = memo(({ styles = {}, url = CALENDLY_URL.DEMO }) => {
    const utm = useMemo(() => getCalendlyUtmParams(), []);

    return (
        <div style={{ ...styles }}>
            <InlineWidget
                url={url}
                styles={{ height: '100%', width: '100%' }}
                utm={utm}
            />
        </div>
    );
});
